import { useApolloClient } from "@apollo/client/react";
import { useCallback, useLayoutEffect, useRef } from "react";
import { runClientQueryAsPromise } from "src/apollo/runClientQueryAsPromise";

// the useLazyQuery hook from apollo client does not return a promise,
// so creating a wrapper on client.query which make promise chaining easier.
// TODO: may be add fetchPolicy to the params?
const useLazyLoad = ({ query, additionalVariables }) => {
  const client = useApolloClient();
  const clientRef = useRef(client);
  const additionalVariablesRef = useRef(additionalVariables);
  useLayoutEffect(() => {
    clientRef.current = client;
    additionalVariablesRef.current = additionalVariables;
  });

  const load = useCallback(
    (variables) =>
      runClientQueryAsPromise(clientRef.current, {
        query,
        variables: {
          ...additionalVariablesRef.current,
          ...variables,
        },
      }),
    [query]
  );

  return load;
};

export default useLazyLoad;
